<div #invitationMemberModal class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content border-radius-0">
      <div class="modal-header text-uppercase py-2 font-size-16">
        @if (project?.isInTenderingMode) {
          <div class="modal-title" i18n="@@app.information_and_link_to_the_call_for_tenders">Information and link to the call for tenders</div>
        } @else {
          <div class="modal-title" i18n="@@app.members">Members</div>
        }
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </div>
      <div class="modal-body">
        @if (user?.email === project?.projectOwner.email) {
          <p>
            @if (project?.isInTenderingMode) {
              <p i18n="@@app.tendering_mode_info_message">This project is in tendering mode. It is locked and cannot be edited by any user, but can be shared. You can always make adjustments by copying this project to create a new editable one.</p>
            }
            <b i18n="@@app.share_link">Share Link</b>
          </p>
        }
        @if (user?.email === project?.projectOwner.email) {
          <div class="d-flex">
            @if (project?.canEditProject) {
              <div class="flex-width-36-percents">
                <select class="form-control font-size-s cursor-pointer form-control-plaintext text-uppercase" (change)="onSelectRole(isIncomingUserEditor)"
                  [(ngModel)]="isIncomingUserEditor">
                  <option class="font-size-m" i18n="@@app.invite_as_editor" [ngValue]="true">Invite as Editor</option>
                  <option class="font-size-m" i18n="@@app.invite_as_viewer" [ngValue]="false">Invite as Viewer</option>
                </select>
              </div>
            }
            <div class="flex-width-59-percents mx-2">
              <input #shareLinkInput
                type="text"
                (focusin)="copyInvitationLinkToClipboard(shareLinkInput)"
                class="form-control font-size-s"
                i18n-placeholder="@@app.share_link"
                placeholder="Share link"
                [value]="link">
              </div>
              <ng-template #copyIconInner>
                <div class="icon-wrapper cursor-pointer bg-light-green">
                  <img src="/assets/images/clone_white_icon.svg" alt="">
                </div>
              </ng-template>
              @if (project?.isInTenderingMode) {
                <div [appUITooltip]="true" [hideTooltipAfterMs]="3000" [trigger]="'manual'" i18n-ttitle="@@app.invitation_copied_indefinitely" ttitle="The invitation has been copied to the clipboard and is valid indefinitely" placement="top" class="flex-width-5-percents icon-flex" (click)="copyInvitationLinkToClipboard(shareLinkInput)">
                  <ng-container *ngTemplateOutlet="copyIconInner"></ng-container>
                </div>
              } @else {
                <div [appUITooltip]="true" [hideTooltipAfterMs]="3000" [trigger]="'manual'" i18n-ttitle="@@app.invitation_copied_to_clipboard" ttitle="Invitation copied to clipboard" placement="top" class="flex-width-5-percents icon-flex" (click)="copyInvitationLinkToClipboard(shareLinkInput)">
                  <ng-container *ngTemplateOutlet="copyIconInner"></ng-container>
                </div>
              }
            </div>
          }
          <div class="row mt-3">
            <div class="col-12">
              <p>
                <ng-container><b i18n="@@app.owner">Owner</b></ng-container>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="bg-blue-gray overflow-y-auto overflow-x-hidden mb-3">
                <div class="px-3 py-2 d-flex align-items-center justify-content-between">
                  <div class="flex-auto">
                    <div class="d-flex align-items-center">
                      <img alt="" src="{{project?.projectOwner?.avatar}}" title="{{project?.projectOwner?.firstName + ' ' + project?.projectOwner?.lastName}}" width="28px" height="28px"
                        class="cursor-pointer rounded-circle mr-3"/>
                        <div>
                          <div class="font-size-11 font-weight-semibold">{{project?.projectOwner?.firstName}} {{project?.projectOwner?.lastName}} @if (user?.email === project?.projectOwner?.email) {
                            (
                            <ng-container i18n="@@app.you">you</ng-container>
                            )
                          }
                        </div>
                        <div class="font-size-11 color-se-gray">{{project?.projectOwner?.email}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="flex-width-20-percents">
                    <div class="text-uppercase text-center font-size-11 color-se-gray font-weight-semibold ml-2" i18n="@@app.owner">Owner</div>
                  </div>
                  <div class="flex-width-10-percents">
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (project?.projectMembers?.length > 0) {
            <div class="row">
              <div class="col-12">
                <p>
                  <ng-container><b i18n="@@app.members">Members</b>  (<b>{{ project?.projectMembers?.length }}</b>)</ng-container>
                </p>
              </div>
            </div>
          }
          @if (project?.projectMembers?.length > 0) {
            <div class="row">
              <div class="col-12">
                <div class="bg-blue-gray overflow-y-auto overflow-x-hidden members-area">
                  <!-- repeat -->
                  @for (member of (project?.projectMembers | removeInactiveUsers); track member) {
                    <div class="px-3 py-2 d-flex align-items-center justify-content-between">
                      <div class="flex-auto">
                        <div class="d-flex align-items-center">
                          <img src="{{member?.avatar}}" alt="" [title]="member?.firstName + ' ' + member?.lastName" width="28px" height="28px"
                            class="cursor-pointer rounded-circle mr-1"/>
                            <img class="cursor-pointer mr-2 viewer-editor-icon" alt="" [title]="member?.firstName + ' ' + member?.lastName" [src]="member?.canEditProject ? roleIcons.EDITOR_ICON : roleIcons.VIEWER_ICON">
                            <div>
                              <div class="font-size-11 font-weight-semibold">{{member?.firstName}} {{member?.lastName}}</div>
                              <div class="font-size-11 color-se-gray">{{member?.email}}</div>
                            </div>
                          </div>
                        </div>
                        @if (project?.canEditProject) {
                          <div class="flex-width-20-percents">
                            @if (user?.email === project?.projectOwner.email) {
                              <div class="cursor-pointer float-right d-flex" id="dropdownMenuButtonRole" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                @if (member?.canEditProject) {
                                  <div class="text-uppercase font-size-11 color-se-gray font-weight-semibold" i18n="@@app.editor">Editor</div>
                                  <img class="ml-1" alt="" src="/assets/images/arrow_down_big_black_icon.svg">
                                }
                                @if (!member?.canEditProject) {
                                  <div class="text-uppercase font-size-11 color-se-gray font-weight-semibold" i18n="@@app.viewer">Viewer</div>
                                  <img class="ml-1" alt="" src="/assets/images/arrow_down_big_black_icon.svg">
                                }
                              </div>
                            }
                            <div class="dropdown-menu fix-dropdown-position overflow-y-auto box-shadow">
                              @if (!member?.canEditProject) {
                                <a (click)="onSwitchRole(true, member?.id)" class="cursor-pointer dropdown-item d-flex align-items-center">
                                  <img class="mr-2" alt="" src="/assets/images/editor.svg">
                                  <div class="text-uppercase font-weight-600 font-size-11" i18n="@@app.change_to_editor">Change to editor</div>
                                </a>
                              }
                              @if (member?.canEditProject) {
                                <a  (click)="onSwitchRole(false, member?.id)" class="cursor-pointer dropdown-item d-flex align-items-center">
                                  <img class="mr-2" alt="" src="/assets/images/viewer.svg">
                                  <div class="text-uppercase font-weight-600 font-size-11" i18n="@@app.change_to_viewer">Change to viewer</div>
                                </a>
                              }
                            </div>
                          </div>
                        }
                        <div class="flex-width-10-percents">
                          @if (project?.canEditProject) {
                            @if (user?.email === project?.projectOwner.email) {
                              <div class="cursor-pointer float-right"
                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <app-settings-dropdown-icon
                                  [hideBorder]="true"
                                  [defaultGrayColor]="true"
                                ></app-settings-dropdown-icon>
                              </div>
                            }
                            <div class="dropdown-menu fix-dropdown-position overflow-y-auto box-shadow">
                              @if (!member?.memberViaShareWithinCompany) {
                                <a (click)="removeUserFromProject(member?.id)" class="cursor-pointer dropdown-item d-flex align-items-center pb-3">
                                  <img class="mr-2" alt="" src="/assets/images/delete_icon.svg">
                                  <div class="text-uppercase font-weight-600 font-size-11 color-icon-red" i18n="@@app.remove_from_project">Remove from project</div>
                                </a>
                              }
                              <a (click)="onTransferOwnership(member)" class="cursor-pointer dropdown-item d-flex align-items-center">
                                <img class="mr-2" alt="" src="/assets/images/transfer_icon.svg">
                                <div class="text-uppercase font-weight-600 font-size-11" i18n="@@app.transfer_ownership">Transfer ownership</div>
                              </a>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <!-- end repeat -->
                  </div>
                </div>
              </div>
            }
            @if (project?.canEditProject && !project?.isInTenderingMode && !project?.isShared) {
              <div class="display-flex justify-content-end mt-3">
                <button class="btn text-color-white rounded-border-btn display-flex align-items-center bg-dark-red" (click)="openTenderingModal()">
                  <i class="top-0 font-size-24 font-weight-semibold se-icon p-0 text-color-white no-select">action_lock_on</i><span i18n="@@app.freeze_the_project_for_the_tender">Freeze the project for the tender</span></button>
                </div>
              }
            </div>
            <div class="modal-footer pt-1 border-0">
            </div>
          </div>
        </div>
      </div>
